import React, { useState, useEffect } from 'react';
import AddPartner from 'features/AddPartner';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core';
import Skeleton from 'components/Skeleton';
import Pagination from '@material-ui/lab/Pagination';
import { BsCheck, BsX } from 'react-icons/bs';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { GoSearch, GoSortDesc } from 'react-icons/go';
import {
  AiOutlineSortAscending,
  AiOutlineSortDescending,
} from 'react-icons/ai';
import images from 'images/images.jfif';
import moment from 'moment';
import {
  pendingUserRequest,
  uploadIdentityProofRequest,
  userAccountControlRequest,
  userRequest,
} from './usersSlice';
import { getImg, showLoader } from '../../utils';
import Modal from 'Modal';
import { showModal } from 'Modal/modalSlice';
import { IoIosArrowBack } from 'react-icons/io';
import { RxCross2 } from "react-icons/rx";
import DragAndDropInputDiv from 'components/DragandDrop';
import ImageCrop from 'components/ImageCrop';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  status: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    margin: '0 auto',
  },
  activate: {
    background: 'green',
  },
  deactivate: {
    background: 'red',
  },
  red: {
    color: 'red',
  },
  green: {
    color: 'green',
  },
  start: {
    textAlign: 'start',
  },
  end: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    columnGap: '0.5rem',
  },
  imgWidth: {
    width: '50px',
  },
  dateInput: {
    width: '190px',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    outline: 'none',
    cursor: 'pointer',
  },
  btn: {
    background: '#45b77c',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    },
  },
  backBtn: {
    background: '#c6c6c6',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#858685',
      color: 'white',
    },
  },
  tableHeaderSort: {
    marginInlineStart: '7px',
  },
  sortIcon: {
    color: 'black',
    cursor: 'pointer',
    '&:hover': {
      color: '#358c5e',
    },
  },
  modal: {
    position: 'fixed',
    width: '100%',
    height: '100vh',
    top: '0',
    left: '0',
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '1000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalChildren: {
    padding: '50px',
    borderRadius: '20px',
    width: 'max-content',
    height: 'max-content',
    maxWidth: '80%',
    maxHeight: '80vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    position: 'relative',
    overflow: 'hidden',
  },
  modalCross: {
    position: 'absolute',
    right: '-5px',
    top: '-5px',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    color: "#303a33",
    borderBottomLeftRadius: '30px',
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 1px, rgba(0, 0, 0, 0.23) 0px 1px 1px',
    '&:hover': {
      boxShadow: ' rgba(0, 0, 0, 0.16) 0px 3px 6px inset, rgba(0, 0, 0, 0.23) 0px 3px 6px inset',
    },
  },
});

export default function Users() {
  const loginType = localStorage.getItem('loginType');
  const dispatch = useDispatch();
  const classes = useStyles();
  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [callStart, setCallStart] = useState(0);
  const [page, setPage] = React.useState(1);
  const loading = useSelector(state => state.user.loading);
  const totalUsers = useSelector(state => state.user.totalList);
  const userList = useSelector(state => state.user.userList);
  const [userData, setUserData] = useState();
  const modalStatus = useSelector(state => state.modal.visibility);
  const totalPages_pre = totalUsers / 10;
  const totalUserPages =
    totalUsers % 10 === 0 ? totalPages_pre : Math.trunc(totalPages_pre) + 1;

  const [allUser, setAllUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [uploadPic, setUploadPic] = useState(false);
  const [receivedFile, setReceivedFile] = useState(false);
  const [imageFile, setImageFile] = useState('');
  const [uploadUserId, setUploadUserId] = useState('');
  const [searchText, setSearchText] = useState('');
  const [sortType, setSortType] = useState('createdAt');
  const [sortName, setSortName] = useState(true);
  const [sortCreatedDate, setsortCreatedDate] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  console.log(searchText, fromDate, toDate, 'fromDate');
  console.log(allUser, 'allUser');
  console.log(callStart, 'callStart');
  console.log(uploadUserId, 'uploadUserId');

  const handleChange = event => {
    setSearchText(event.target.value.trim());
    setPage(1);
  };

  useEffect(() => {
    const delay = 500;
    const debounceTimer = setTimeout(() => {
      getAllUsers();
    }, delay);
    return () => clearTimeout(debounceTimer);
    // eslint-disable-next-line
  }, [searchText]);

  useEffect(() => {
    setAllUser(Object.values(userList));
  }, [userList]);

  useEffect(() => {
    setCallStart((page - 1) * 10);
  }, [page]);

  const getSortType = val => {
    if (val === 'createdAt') {
      if (sortCreatedDate) {
        return -1;
      } else {
        return 1;
      }
    } else {
      if (sortName) {
        return 1;
      } else {
        return -1;
      }
    }
  };

  const getAllUsers = () => {
    const obj = {
      keyword: searchText,
      fromDate: fromDate,
      toDate: toDate,
      sortBy: sortType,
      sortType: getSortType(sortType),
      type: 'all',
    };
    dispatch(
      userRequest({
        data: obj,
        start: callStart,
        limit: 10,
      })
    );
  };

  useEffect(() => {
    getAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    callStart,
    sortName,
    sortCreatedDate,
    sortType,
    fromDate,
    toDate,
  ]);

  const handlePageChange = value => {
    setPage(value);
  };

  const addPartner = () => {
    setShow(false);
    setShow1(true);
    setShowUsers(true);
    setShowAddBtn(false);
  };

  const users = () => {
    setShow(true);
    setShow1(false);
    setShowUsers(false);
    setShowAddBtn(true);
  };

  const pageFunc = () => {
    if (totalUserPages) {
      return totalUserPages;
    }
    return 0;
  };

  const handleUserAccountControl = (type, userId) => {
    const obj = {
      type: type,
      users: [userId],
    };
    dispatch(userAccountControlRequest({ data: obj }));
    handleClose();
  };

  const handleViewImage = user => {
    if (user.identityProof) {
      dispatch(showModal({ id: user._id }));
      setUserData(user);
      setAnchorEl(null);
    }
  };

  const getStatusValues = (status, a, b) => {
    return status ? a : b;
  };

  const open = Boolean(anchorEl);

  const handleClick = (event, user) => {
    console.log(event.currentTarget, "handleClick")
    setAnchorEl(event.currentTarget);
    setSelectedUser(user._id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePendingUser = id => {
    console.log(id, 'handlePendingUser');
    dispatch(pendingUserRequest({
      data: {
        userIds: [id],
        status: "pending",
      }
    }));
    handleClose();
    setTimeout(() => {
      getAllUsers();
    }, 1000);
  };

  const handleUpload = id => {
    setUploadPic(true);
    setUploadUserId(id)
    console.log(id, 'handleUpload');
    handleClose();
  };
  const getFile = file => {
    console.log(file, "getFile")
    setUploadPic(false);
    setReceivedFile(true);
    setImageFile(file);
  };
  const getCropImgMyProfile = (files) => {
    setReceivedFile(false);

    // Create a FormData object
    const formData = new FormData();

    // Append the file to the FormData
    formData.append('userId', uploadUserId);
    formData.append('image', files);

    // Dispatch the action with the FormData as payload
    dispatch(uploadIdentityProofRequest({ data: formData, func: getAllUsers }));

    // Reset state or perform any other necessary actions
    setImageFile('');
  };

  const handleModalCancelMyProfile = () => {
    setReceivedFile(false);
  }


  const menu = user => {
    return (
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>

        {user.onboardingCompleted && !user.isVerified ? (
          <MenuItem onClick={() => handleUserAccountControl(3, user._id)}>
            Verify User
          </MenuItem>
        ) : null}
        {user.isVerified && user.status ? (
          <MenuItem
            onClick={() =>
              handleUserAccountControl(
                (user.loginType === 1 && 2) || (user.loginType === 2 && 1),
                user._id
              )
            }
          >
            {(user.loginType === 1 && 'Make Standard User') ||
              (user.loginType === 2 && 'Make Admin')}
          </MenuItem>
        ) : null}

        {user.isVerified ? (
          <MenuItem
            onClick={() =>
              handleUserAccountControl(
                getStatusValues(user.status, 4, 3),
                user._id
              )
            }
          >
            {getStatusValues(
              user.status,
              'Deactivate Account',
              'Activate Account'
            )}
          </MenuItem>
        ) : null}
         {!user.onboardingCompleted && ( 
          <MenuItem onClick={() => handlePendingUser(user._id)}>
            Move to Pending User
          </MenuItem>
        )} 
        <MenuItem onClick={() => handleUpload(user._id)}>
          Upload Identity Proof
        </MenuItem>
      </Menu>
    );
  };
  const getAddBtn = val => {
    if (val) {
      return (
        <Grid item xs={12} className={classes.end}>
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            onClick={addPartner}
          >
            Add Partner
          </Button>
        </Grid>
      );
    }
  };

  const getBackBtn = val => {
    if (val) {
      return (
        <Grid item xs={6} className={classes.start}>
          <Button variant="contained" className={classes.backBtn} onClick={users}>
            <IoIosArrowBack size={20} /> <span>Back</span>
          </Button>
        </Grid>
      );
    }
  };
  const getAddPartner = val => {
    if (val) {
      return (
        <Grid item xs={12}>
          <AddPartner />
        </Grid>
      );
    }
  };
  const getLoginType = val => {
    switch (val) {
      case 1:
        return 'ADMIN';
      case 2:
        return 'USER';
      case 3:
        return 'PARTNER';
      default:
        break;
    }
  };
  const showImg = val => {
    if (val) {
      return getImg(val);
    } else {
      return images;
    }
  };
  const getVerify = val => {
    if (val) {
      return <BsCheck size={30} className={classes.green} />;
    } else {
      return <BsX size={30} className={classes.red} />;
    }
  };
  const getAction = (data) => {
    return (
      <Button onClick={e => handleClick(e, data)}>
        <BiDotsVerticalRounded style={{ fontSize: '28px' }} />
      </Button>
    );
  };

  const renderTable = () => {
    return (
      <>
        {parseInt(loginType) === 1 ? (
          <>
            <div className={classes.root}>
              <Grid container spacing={3}>
                {getBackBtn(showUsers)}
                {getAddBtn(showAddBtn)}
                {show && (
                  <>
                    <Grid item xs={12}>
                      <div
                        style={{
                          padding: '0 22px',
                          width: '100%',
                          // background: 'blue',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-around',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            // background: 'red',
                          }}
                        >
                          <GoSearch
                            style={{
                              margin: '16px 10px 0 0',
                            }}
                            size={18}
                            color="#c9c9c9"
                          />

                          <TextField
                            id="standard-basic"
                            label="Search"
                            variant="standard"
                            onChange={handleChange}
                          />
                        </div>
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '50px',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '20px',
                            }}
                          >
                            <div>From</div>
                            <input
                              type="date"
                              className={classes.dateInput}
                              onChange={e => setFromDate(e.target.value)}
                              max={new Date().toISOString().split('T')[0]}

                            />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '20px',
                            }}
                          >
                            <div>To</div>
                            <input
                              type="date"
                              className={classes.dateInput}
                              onChange={e => setToDate(e.target.value)}
                              min={fromDate}
                              max={new Date().toISOString().split('T')[0]}
                            />
                          </div>
                        </div>
                      </div>
                      <TableContainer
                        className={classes.container}
                        component={Paper}
                      >
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Profile Image
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Identity Proof Image
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Gender
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                <span>Name</span>
                                <span className={classes.tableHeaderSort}>
                                  {sortName ? (
                                    <AiOutlineSortAscending
                                      size={22}
                                      className={classes.sortIcon}
                                      onClick={() => {
                                        setSortType('userName');
                                        setSortName(!sortName);
                                      }}
                                    />
                                  ) : (
                                    <AiOutlineSortDescending
                                      size={22}
                                      className={classes.sortIcon}
                                      onClick={() => {
                                        setSortType('userName');
                                        setSortName(!sortName);
                                      }}
                                    />
                                  )}
                                </span>
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Email
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                WBO
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Login Type
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Status
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Onboarding Completed
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Is Verified
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                <span>Created At</span>
                                <span className={classes.tableHeaderSort}>
                                  <GoSortDesc
                                    size={22}
                                    className={classes.sortIcon}
                                    style={{
                                      transform: `${sortCreatedDate
                                        ? 'rotate(0deg)'
                                        : 'rotate(180deg)'
                                        }`,
                                    }}
                                    onClick={() => {
                                      setSortType('createdAt');
                                      setsortCreatedDate(!sortCreatedDate);
                                    }}
                                  />
                                </span>
                              </TableCell>

                              <TableCell
                                align="center"
                                className={classes.tabelHeaderColor}
                              >
                                Action
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {allUser?.map(user => (
                              <TableRow key={user._id} align="center">
                                <TableCell align="center">
                                  <img
                                    src={showImg(user.image)}
                                    alt="profile pic"
                                    className={classes.imgWidth}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <img
                                    onClick={() => handleViewImage(user)}
                                    src={showImg(user.identityProof)}
                                    alt="identity proof pic"
                                    className={classes.imgWidth}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  {user.gender}
                                </TableCell>
                                <TableCell align="center">
                                  {user.userName}
                                </TableCell>
                                <TableCell align="center">
                                  {user.email}
                                </TableCell>
                                <TableCell align="center">{user.WBO}</TableCell>
                                <TableCell align="center">
                                  {getLoginType(user.loginType)}
                                </TableCell>
                                <TableCell align="center">
                                  <div
                                    className={`${classes.status} ${user.status
                                      ? classes.activate
                                      : classes.deactivate
                                      }`}
                                  ></div>
                                </TableCell>
                                <TableCell align="center">
                                  {getVerify(user.onboardingCompleted)}
                                </TableCell>
                                <TableCell align="center">
                                  {getVerify(user.isVerified)}
                                </TableCell>
                                <TableCell align="center">
                                  {moment(user.createdAt).format('DD-MM-YYYY')}
                                </TableCell>

                                <TableCell align="center">
                                  {getAction(user)}
                                  {selectedUser === user._id && menu(user)}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <div style={{ textAlign: 'center' }}>
                          {allUser?.length === 0 && 'No Data'}
                        </div>
                      </TableContainer>
                      <div className={classes.pagination}>
                        <Pagination
                          color="primary"
                          count={pageFunc()}
                          page={page}
                          onChange={(_e, val) => handlePageChange(val)}
                        />
                      </div>
                    </Grid>
                  </>
                )}
                {getAddPartner(show1)}
              </Grid>
            </div>
          </>
        ) : (
          ''
        )}
      </>
    );
  };

  return (
    <>
      <Skeleton>
        {renderTable()}



        {modalStatus ? (
          <Modal
            title="View Image"
            type="viewImage"
            modalStyles={{ width: '40%' }}
            data={{
              data: userData,
            }}
          />
        ) : (
          ''
        )}
        {uploadPic ? (
          <div className={classes.modal}>
            <div className={classes.modalChildren}>
              <div className={classes.modalCross} onClick={() => setUploadPic(false)}><RxCross2 size={30} /></div>
              <DragAndDropInputDiv getFile={getFile} />
            </div>
          </div>
        ) : (
          ''
        )}
        {receivedFile && imageFile ? (
          <div className={classes.modal}>
            <div className={classes.modalChildren}>
              <ImageCrop
                src={imageFile}
                onImageLoaded={setImageFile}
                circularCrop={false}
                activeBorder={true}
                getImage={getCropImgMyProfile}
                cropCancel={handleModalCancelMyProfile}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        {showLoader(loading, 'transparent')}
      </Skeleton>

    </>
  );
}
